import { Fragment } from 'react'

// Plan documents mark emphasis inline: **bold** and *italic*. Paragraphs are separated by a blank line.
const TOKEN = /(\*\*[^*]+\*\*|\*[^*]+\*)/g

export function renderInline(text) {
  return String(text ?? '').split(TOKEN).filter(Boolean).map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) return <strong key={i} className="font-semibold">{part.slice(2, -2)}</strong>
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) return <em key={i}>{part.slice(1, -1)}</em>
    return <Fragment key={i}>{part}</Fragment>
  })
}

export default renderInline
